import React, { FC } from 'react';
import cn from 'classnames';
require("./Textarea-Label.css");
var styles = {
  "Root": "Textarea-Label-module-Root_2MJ",
  "required": "Textarea-Label-module-required_2Fv"
};
export const TextareaLabel = ({
  className,
  title = '',
  required,
  id
}) => /*#__PURE__*/React.createElement("label", {
  className: cn(styles.Root, className),
  htmlFor: id
}, title, required && /*#__PURE__*/React.createElement("sup", {
  className: styles.required
}, "\u2731"));